export default __webpack_public_path__ + "static/cicada-c05abcf728064cdcb56d2800c637bb51.svg";